const Permission = {
    ALL: "ALL",
    SUPER_ADMIN: "SUPER_ADMIN",
    READ_DASHBOARD: "READ_DASHBOARD",

    CREATE_USER: "CREATE_USER",
    READ_SINGLE_USER: "READ_SINGLE_USER",
    READ_USERS: "READ_USERS",
    UPDATE_USER: "UPDATE_USER",
    UPDATE_USERS: "UPDATE_USER",
    DELETE_USER: "DELETE_USER",
    DELETE_USERS: "DELETE_USER",
    DISABLE_USER: "DISABLE_USER",
    DISABLE_USERS: "DISABLE_USER",
    READ_PROFILE: "READ_PROFILE",
    UPDATE_PROFILE: "UPDATE_PROFILE",
    READ_SINGLE_PROFILE: "READ_SINGLE_PROFILE",
    READ_LITE_PROFILE: "READ_LITE_PROFILE",
    UPDATE_USERS_PASSWORD: "UPDATE_USERS_PASSWORD",
    UPDATE_PASSWORD: "UPDATE_PASSWORD",

    CREATE_ROLE: "CREATE_ROLE",
    UPDATE_ROLE: "UPDATE_ROLE",
    READ_ROLES: "READ_ROLES",
    READ_SINGLE_ROLE: "READ_SINGLE_ROLE",
    DELETE_ROLE: "DELETE_ROLE",

    CREATE_PAYMENT: "CREATE_PAYMENT",
    READ_PAYMENTS: "READ_PAYMENTS",
    READ_SINGLE_PAYMENT: "READ_SINGLE_PAYMENT",
    UPDATE_PAYMENT: "UPDATE_PAYMENT",
    DELETE_PAYMENT: "DELETE_PAYMENT",

    CREATE_PARTNER: "CREATE_PARTNER",
    READ_PARTNERS: "READ_PARTNERS",
    READ_SINGLE_PARTNER: "READ_SINGLE_PARTNER",
    UPDATE_PARTNER: "UPDATE_PARTNER",
    DELETE_PARTNER: "DELETE_PARTNER",

    CREATE_GAME: "CREATE_GAME",
    READ_GAMES: "READ_GAMES",
    READ_SINGLE_GAME: "READ_SINGLE_GAME",
    UPDATE_GAME: "UPDATE_GAME",
    DELETE_GAME: "DELETE_GAME",

    CREATE_PROMOTION: "CREATE_PROMOTION",
    READ_PROMOTIONS: "READ_PROMOTIONS",
    READ_SINGLE_PROMOTION: "READ_SINGLE_PROMOTION",
    UPDATE_PROMOTION: "UPDATE_PROMOTION",
    DELETE_PROMOTION: "DELETE_PROMOTION",

    CREATE_AFFILIATE: "CREATE_AFFILIATE",
    READ_AFFILIATES: "READ_AFFILIATES",
    READ_SINGLE_AFFILIATE: "READ_SINGLE_AFFILIATE",
    UPDATE_AFFILIATE: "UPDATE_AFFILIATE",
    DELETE_AFFILIATE: "DELETE_AFFILIATE",

    CREATE_SUPPORT: "CREATE_SUPPORT",
    READ_SUPPORTS: "READ_SUPPORTS",
    READ_SINGLE_SUPPORT: "READ_SINGLE_SUPPORT",
    UPDATE_SUPPORT: "UPDATE_SUPPORT",
    DELETE_SUPPORT: "DELETE_SUPPORT",

    CREATE_CONTENT: "CREATE_CONTENT",
    READ_CONTENTS: "READ_CONTENTS",
    READ_SINGLE_CONTENT: "READ_SINGLE_CONTENT",
    UPDATE_CONTENT: "UPDATE_CONTENT",
    DELETE_CONTENT: "DELETE_CONTENT",

    READ_SETTINGS: "READ_SETTINGS",
    READ_SINGLE_SETTING: "READ_SINGLE_SETTING",
    UPDATE_SETTING: "UPDATE_SETTING",
    READ_COMPLIANCE: "READ_COMPLIANCE",
    UPDATE_COMPLIANCE: "UPDATE_COMPLIANCE",
    CREATE_REPORT: "CREATE_REPORT",
    READ_REPORTS: "READ_REPORTS",
    READ_SINGLE_REPORT: "READ_SINGLE_REPORT",
    UPDATE_REPORT: "UPDATE_REPORT",
    DELETE_REPORT: "DELETE_REPORT",
    READ_ACTIVITY_LOGS: "READ_ACTIVITY_LOGS",
    READ_SINGLE_ACTIVITY_LOG: "READ_SINGLE_ACTIVITY_LOG",
    DELETE_ACTIVITY_LOG: "DELETE_ACTIVITY_LOG",

    CREATE_STATIC_PAGE: "CREATE_STATIC_PAGE",
    UPDATE_STATIC_PAGE: "UPDATE_STATIC_PAGE",
    READ_STATIC_PAGES: "READ_STATIC_PAGES",
    READ_SINGLE_STATIC_PAGE: "READ_SINGLE_STATIC_PAGE",
    DELETE_STATIC_PAGE: "DELETE_STATIC_PAGE"
};

export default Permission;
